module.exports = __webpack_public_path__ + "img/eightday1-2.9ee4f81c.jpg";